import { connect } from 'react-redux';
import { doInitializeBaseData } from '../../../actions/BaseData';
import { changeContext, doRetrieveContexts as _doRetrieveContexts } from '../../../actions/Contexts';
import { addFlag } from '../../../actions/Flags';
import { doStartAppSpecificPasswordInstallMode } from '../../../actions/Installation/InstallMode/AppSpecificPassword';
import { doInitiateInstallModeForIdentifier } from '../../../actions/Installation/InstallMode/DeterminingInstallMode';
import { doRetrieveFreshInstalledApps } from '../../../actions/InstalledApps';
import { feedbackSuccessFlag } from '../../common/FeedbackCollector';
import AppContainer from '../AppContainer';
const mapStateToProps = state => ({
  analyticsLoadResult: state.analytics.analyticsLoadResult,
  contexts: state.contexts.contexts,
  currentUserId: state.users.currentUserId,
  featureFlags: state.configuration.featureFlags,
  hostConfig: state.configuration.hostConfig,
  hostInfo: state.configuration.hostInfo,
  isContextsLoading: state.contexts.isContextsLoading,
  selectedContext: state.contexts.selectedContext,
  hostPricing: state.hostPricing.hostPricing
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  doRetrieveContexts: filter => dispatch(_doRetrieveContexts(filter)),
  initializeBaseData: props => dispatch(doInitializeBaseData({
    bootstrapConfig: ownProps.bootstrapConfig,
    statsigClientMpac: props.statsigClientMpac
  })),
  onFeedbackSubmit: () => dispatch(addFlag({
    flag: feedbackSuccessFlag
  })),
  onSelectedContextChanged: newContext => dispatch(changeContext(newContext)),
  openAppSpecificPasswordDialog: _ref => {
    let {
      name
    } = _ref;
    return dispatch(doStartAppSpecificPasswordInstallMode({
      name
    }));
  },
  openInstallDialog: _ref2 => {
    let {
      installableAppId,
      relayState,
      context
    } = _ref2;
    return dispatch(doInitiateInstallModeForIdentifier({
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
      installableAppId,
      relayState,
      context
    }));
  },
  retrieveFreshInstalledApps: _ref3 => {
    let {
      context,
      hostConfig,
      search,
      flags,
      offset
    } = _ref3;
    return dispatch(doRetrieveFreshInstalledApps({
      context,
      hostConfig,
      search,
      flags,
      offset
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);